const getDefaultState = () => {
  return {
    headquarter: null,
    company: null,
    able_companies: [],
    design_datas: {
      img_logo: {},
      // 明るい背景用ロゴ（設計書 docs/plans/2026-09-25-cli-ui-redesign-design.md 4.2）
      img_logo_light: {},
      img_header: {},
      img_side: {},
      img_trial_bk: {},
      primary_color: "#2F54EB",
      header_color: "#1D1E1F",
      side_color: "#1D1E1F",
      body_color: "#F7F9FC",
      footer_color: "#FFFFFF",
      trial_color: "#F7F9FC",
      header_text_color: "#FFFFFF",
      side_text_color: "#FFFFFF",
      body_text_color: "#0A1233",
      footer_text_color: "#7A8099",
      trial_text_color: "#0A1233",
    },
    survey: null,
  }
}

export const state = () => (getDefaultState())
export const mutations = {
  setHeadquarter(state, headquarter) {
    if(state.headquarter == null || state.headquarter.design_updated_at !== headquarter.design_updated_at){
      state.design_datas.img_logo = headquarter.img_logo
      state.design_datas.img_logo_light = headquarter.img_logo_light
      state.design_datas.img_header = headquarter.img_header
      state.design_datas.img_side = headquarter.img_side
      state.design_datas.img_trial_bk = headquarter.img_trial_bk
      state.design_datas.primary_color = headquarter.design_settings.primary_color
      state.design_datas.header_color = headquarter.design_settings.header_color
      state.design_datas.side_color = headquarter.design_settings.side_color
      state.design_datas.body_color = headquarter.design_settings.body_color
      state.design_datas.footer_color = headquarter.design_settings.footer_color
      state.design_datas.trial_color = headquarter.design_settings.trial_color
      state.design_datas.header_text_color = headquarter.design_settings.header_text_color
      state.design_datas.side_text_color = headquarter.design_settings.side_text_color
      state.design_datas.body_text_color = headquarter.design_settings.body_text_color
      state.design_datas.footer_text_color = headquarter.design_settings.footer_text_color
      state.design_datas.trial_text_color = headquarter.design_settings.trial_text_color
      state.design_datas.app_lesson_title = headquarter.design_settings.app_lesson_title
      state.design_datas.app_calendar_title = headquarter.design_settings.app_calendar_title
      // イベントの担当講師の呼び名（2026-10-20。CMP と同じ呼び名。未設定は utils/eventDisplay の既定「インストラクター」）
      state.design_datas.app_instructor_title = headquarter.design_settings.app_instructor_title
      state.design_datas.app_calendar_gym_title = headquarter.design_settings.app_calendar_gym_title
      state.design_datas.app_calendar_self_title = headquarter.design_settings.app_calendar_self_title
      state.design_datas.app_training_log_title = headquarter.design_settings.app_training_log_title
      state.design_datas.app_training_log_footer_title = headquarter.design_settings.app_training_log_footer_title
      state.design_datas.app_training_log_icon = headquarter.design_settings.app_training_log_icon
      state.design_datas.app_training_event_title = headquarter.design_settings.app_training_event_title
      state.design_datas.app_training_event_footer_title = headquarter.design_settings.app_training_event_footer_title
      state.design_datas.app_training_event_icon = headquarter.design_settings.app_training_event_icon
    }
    state.headquarter = headquarter
  },
  setCompany(state, company) {
    // 店舗設定でうわ書く（旧来の値。画面のロゴはここを読まず utils/logo.js の resolveLogos で本部・店舗から決める・トラッカー S9）
    if(state.company == null || state.company.design_updated_at !== company.design_updated_at){
      state.design_datas.img_logo = company.img_logo.url ? company.img_logo : state.headquarter.img_logo
    }
    state.company = company
  },
  setAbleCompanies(state, able_companies) {
    state.able_companies = able_companies
  },
  clearSurvey(state){
    state.survey = null
  },
  setSurvey(state, survey){
    state.survey = survey
  },
  clearAllData(state) {
    Object.assign(state, getDefaultState())
    window.storeCtl.commit("master/reset")
  },
}
// 戻り地はisBeforeRequest
export const actions = {
}
